import { render } from "./EditPagePreviewItem.vue?vue&type=template&id=0b5141e8&scoped=true"
import script from "./EditPagePreviewItem.vue?vue&type=script&lang=js"
export * from "./EditPagePreviewItem.vue?vue&type=script&lang=js"

import "./EditPagePreviewItem.vue?vue&type=style&index=0&id=0b5141e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5141e8"]])

export default __exports__